import {
  CatalogFiltersOptions,
  CatalogFiltersState,
  AdditionalFilters
} from '../../types'
import { FiltersState } from './filters/_state'
import { FiltersURL } from './filters/_url'
import { FiltersDOM } from './filters/_dom'
import { FiltersEvents } from './filters/_events'

/**
 * Класс для управления фильтрами каталога квестов
 */
export class CatalogFilters {
  private state: FiltersState
  private url: FiltersURL
  private dom: FiltersDOM
  private events: FiltersEvents
  private options: CatalogFiltersOptions

  /**
   * Создаёт экземпляр CatalogFilters
   *
   * @param {CatalogFiltersOptions} options - Опции фильтров
   */
  constructor(options: CatalogFiltersOptions) {
    this.options = options
    const tags = options.tags || []
    const categories = options.categories

    this.state = new FiltersState(tags)
    this.url = new FiltersURL(this.state)
    this.dom = new FiltersDOM(options.element, this.state, categories)

    this.events = new FiltersEvents(
      options.element,
      this.state,
      this.dom,
      this.url,
      options
    )

    this.init()
  }

  private init(): void {
    this.url.loadFromURL()
    this.dom.dropHiddenFilters()
    // Ссылка с original=1: выдача уже отфильтрована, кнопка должна быть включена.
    this.dom.updateOriginalButton()
    this.dom.syncDropdowns()
    this.events.bindEvents()
    this.events.applyInitialFilters()

    setTimeout(() => {
      this.events.setInitialFiltersSet(true)
    }, 0)
  }

  /**
   * Устанавливает дополнительные фильтры и обновляет UI
   *
   * @param {AdditionalFilters} filters - Объект дополнительных фильтров
   * @param {boolean} hasNonDefault - Есть ли непустые фильтры
   */
  // Публичные методы
  public setAdditionalFilters(
    filters: AdditionalFilters,
    hasNonDefault: boolean
  ): void {
    this.state.setAdditionalFilters(filters, hasNonDefault)
    this.dom.updateMoreFiltersButton()

    const filtersData = this.state.getFiltersData()
    this.url.updateURL(filtersData)
    this.dom.updateResetButton()

    if (this.options.onAdditionalFiltersChange) {
      this.options.onAdditionalFiltersChange(hasNonDefault)
    }
  }

  /**
   * Возвращает текущее состояние фильтров
   *
   * @return {any} Объект состояния
   */
  public getState(): CatalogFiltersState {
    return this.state.getState()
  }

  /**
   * Уничтожает экземпляр фильтров
   */
  public destroy(): void {
    // Обработчики событий будут удалены автоматически при уничтожении объекта
  }
}
